if (ht.CentralExchange) {
  $('#CentralDataInit').each(function () {
    var opts = $(this).metadata().CentralDataManagerOpts;
    ht.CentralDataManager.init(opts);
  });
}
